import { makeStyles } from 'lib/components';

export default makeStyles({
  disclaimer: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '11px',
    fontWeight: '500',
    color: '#555863',
    borderLeft: '1px solid #D1D2D4',
    borderRight: '1px solid #D1D2D4',
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    padding: '0 5px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px 0px 0px 0px',
    background: 'rgba(255, 255, 255, 0.8)',
    '@media (max-width: 600px)': {
      borderRadius: '0px',
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      fontWeight: '600',
    },
  },
});
